import { render, staticRenderFns } from "./BarChartProfitPerNetwork.vue?vue&type=template&id=34d177ab&scoped=true"
import script from "./BarChartProfitPerNetwork.js?vue&type=script&lang=js&external"
export * from "./BarChartProfitPerNetwork.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d177ab",
  null
  
)

export default component.exports